<template>
  <el-tooltip :disabled="multipleSelection.length > 0"
              content="请勾选工单前的数据多选框"
              placement="top"
              effect="dark">
    <el-button type="danger"
               size="mini"
               :disabled="multipleSelection.length <= 0"
               @click="onSubmit">
      <slot></slot>
    </el-button>
  </el-tooltip>
</template>

<script>

export default {
  components: {},
  props: {
    multipleSelection: Array,
  },
  methods: {
    onSubmit () {
      let multipleIds = {
        'order_ids': this.multipleSelection.map(item => item.orderid),
      }
      if (multipleIds.order_ids.length <= 0) {
        this.$message.error('请至少选择批量通过一个')
        return false
      }
      this.$confirm('是否批量通过工单?', '操作确认', {}).then(() => {
        this.batchPass(multipleIds)
      }).catch(action => {
        console.log('取消批量通过操作')
      })
    },
    batchPass (multipleIds) {
      return request.common('batchSucceed', multipleIds).then((res) => {
        let message = '批量通过，成功' + res.data.success.length + '个,共' + multipleIds.order_ids.length + '个'
        if (res.data.success.length < multipleIds.order_ids.length) {
          message += ',失败id' + res.data.success.join(',')
        }
        this.$message({
          showClose: true,
          message: message,
          type: 'success',
        })
        this.$emit('batchSucceed')
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/order/components/buttons/OrderBatchSucceedButton.vue